<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  methods: {
    isMobile() {
      return globalState.viewport.sm || globalState.viewport.xs;
    },
  },
  mounted() {
    Vue.nextTick(() => {
      setTimeout(() => {
        if (window.location.href.includes("?open-chat") && !this.isMobile()) {
          openChat();
        }
      }, 1000);
    });
  }
};
</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="[contentType, {'secondary-navbar-present': !!content.navbar}, theme]" 
    v-if="isContentVisibleToUser()" 
    page-blank-component
  >
    <breadcrumb :breadcrumb="pageModel.breadcrumb" v-if="content.breadcrumb"></breadcrumb>
    <component 
      :is="stripe.layout" 
      :content="stripe" 
      v-for="(stripe, index) in content.stripes" 
      :key="stripe.$id" 
      :opt-container-content="containerContent"
      :class="{'first': !index}"
    ></component>
    <vote-interaction class="my-md-5 pb-3" :content="content" v-if="content.vote"></vote-interaction>
    <related-collections :content="content"></related-collections>
  </div>
</template>

<style lang="scss">
[page-blank-component] {
  background-color: var(--theme-background);
  position: relative;

  &.secondary-navbar-present .breadcrumb-container {
    top: $secondary-nav-height;
  }

  &.secondary-navbar-present {
    .first .mh-100vh-header {
      min-height: calc(100vh - #{$header-height} - #{$secondary-nav-height});
    }

    .first .h-100vh-header {
      height: calc(100vh - #{$header-height} - #{$secondary-nav-height});
    }
  }

}
</style>
